
<div class="theme-default">



  <div id="app">
    <div class="app__container">

      @if (loading) {
        <div class="row mb-5">
          <div class="col-4 mx-auto">
            <div class="nauk-info-connections text-center">
              <div class="c-loading__wrapper">
                <div class="c-loading__icon">
                  <svg class="c-loading__top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.6 62.6"><path fill="#fff" d="M0 31.3c0 17.3 14 31.3 31.3 31.3s31.3-14 31.3-31.3S48.6 0 31.3 0 0 14 0 31.3zm10.2 0c0-11.6 9.5-21.1 21.1-21.1 11.6 0 21.1 9.5 21.1 21.1 0 11.6-9.5 21.1-21.1 21.1-11.6 0-21.1-9.4-21.1-21.1z" /></svg>
                  <svg class="c-loading__bottom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.8 61.4"><path fill="#fff" d="M62.3 52.4c2.1-2.6 6-8.7 5.5-18.7V32.3l-.1-4.5c.3-13.7-6.9-20.6-6.9-20.6C52.7-.4 44.4 0 44.4 0H25.1l-1.9.1S13.4.8 7.3 7.2c0 0-7.8 6.1-7.2 20.7V33.6C0 38 .6 41.7 1.6 44.7c.1.2.1.3.2.5 1.1 3 2.5 5.2 3.6 6.7 3.1 4.2 8.3 8.6 16.6 9.3.6.1.9.1.9.1l2.3.1h19.5s8.9-.7 14.6-5.8c1.2-1.1 2.2-2.1 3-3.2zm-6.1-15.9c0 3.7-1.2 6.8-3.5 9.5-2.4 2.7-5.3 4.1-8.7 4.1H23.3c-3.5 0-6.3-1.3-8.7-4-2.4-2.7-3.5-5.8-3.5-9.5V24.8c0-3.7 1.2-6.8 3.6-9.5 2.3-2.6 5.2-3.9 8.7-3.9H44c3.5 0 6.3 1.3 8.7 4.1 2.4 2.7 3.5 5.7 3.5 9.4v11.6z" /></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <form id="login" class="login__panel" (ngSubmit)="forgotPassword()">

        <img src="assets/images/logo-white.svg" class="login__logo mx-auto mb-xl" alt="JobTrain" />


        @if (success!='') {
          <div class="alert alert-success alert-dismissible fade show mb-5" role="alert">
            {{success}}
            <button type="submit" class="close" data-dismiss="alert" aria-label="Close">
              <svg viewBox="0 0 12 12">
                <path fill="none" d="M0 0h12v12H0V0z" />
                <path class="icon-fill" d="M9.9 2.9l-.8-.8L6 5.3 2.9 2.1l-.8.8L5.3 6 2.1 9.1l.8.8L6 6.7l3.1 3.2.8-.8L6.7 6z" />
              </svg>
            </button>
          </div>
        }
        @if (error!='') {
          <div class="alert alert-danger alert-dismissible fade show mb-5" role="alert">
            {{error}}
            <button type="submit" class="close" data-dismiss="alert" aria-label="Close">
              <svg viewBox="0 0 12 12">
                <path fill="none" d="M0 0h12v12H0V0z" />
                <path class="icon-fill" d="M9.9 2.9l-.8-.8L6 5.3 2.9 2.1l-.8.8L5.3 6 2.1 9.1l.8.8L6 6.7l3.1 3.2.8-.8L6.7 6z" />
              </svg>
            </button>
          </div>
        }

        @if (emailMessage) {
          <div class="alert alert-warning alert-dismissible fade show mb-5" role="alert" >
            Enter your username or email address and a link will be sent for you to reset your password.
            <button type="submit" class="close" data-dismiss="alert" aria-label="Close">
              <svg viewBox="0 0 12 12">
                <path fill="none" d="M0 0h12v12H0V0z" />
                <path class="icon-fill" d="M9.9 2.9l-.8-.8L6 5.3 2.9 2.1l-.8.8L5.3 6 2.1 9.1l.8.8L6 6.7l3.1 3.2.8-.8L6.7 6z" />
              </svg>
            </button>
          </div>
        }


        <input type="text" id="username" class="login__input mb-lg" placeholder="Enter email address" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>




        <button type="submit" class="button button--highlight mb-xl mx-auto">
          Send
        </button>


      </form>




    </div>

  </div>


</div>





<!--<div [className]="'loginForgotPassword'">
<form class="form-signin text-center" (ngSubmit)="forgotPassword()">
  <div>
    <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
  </div>
  <div #container></div>
  <h4 class="h3 mb-3 font-weight-normal" style="color:black">
    Login
  </h4>
  <p>
    Login
  </p>

  <span id="MainContent_diverror" style="display:block; position:relative; padding-bottom:15px; height:30px; width:100%; color:Red;margin-bottom:15px">{{error}}</span>



  <input type="text" id="inputEmail" class="form-control" placeholder="Enter email address" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>
  <br />
  <button class="btn btn-lg btn-primary btn-block forgotPassword btn_resetpassword" type="submit">Login</button>

  <p>&copy; Login</p>
</form>
</div>-->


